<template>
  <el-card shadow="never" class="aui-card--fill">
    <vxe-toolbar ref="xToolbar" custom>
      <template v-slot:buttons>
        <el-form
            :inline="true"
            :model="queryForm"
            @keyup.enter.native="getDataList()"
            ref="queryForm"
            class="query-form"
        >
          <el-form-item prop="sellerName" label="销售方：">
            <el-input v-model="queryForm.sellerName" size="mini" clearable type="text"
                      placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item prop="receiptCode" label="发票号：">
            <el-input v-model="queryForm.receiptCode" size="mini" clearable type="text"
                      placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataList" size="mini">查询</el-button>
            <el-button @click="reset" size="mini">重置</el-button>
            <el-button @click="showPayDialog" size="mini" type="warning">批量付款</el-button>
          </el-form-item>
        </el-form>
      </template>
    </vxe-toolbar>
    <vxe-table
        :id="tableConfig.id"
        :ref="tableConfig.tableName"
        show-overflow
        show-footer
        row-id="id"
        :height="tableConfig.height"
        :loading="tableData.loading"
        :data="tableData.dataList"
        :cell-style="cellStyleHandler"
        :custom-config="{storage: true, checkMethod: checkColumnHandler}"
        :footer-method="tableFooter"
        @resizable-change="resizableChangeEvent">
      <vxe-column type="checkbox" width="50"></vxe-column>
      <vxe-column type="seq" title="行号" width="50"></vxe-column>
      <vxe-column field="sellerName" title="销售方" min-width="160" :formatter="companyNameFormatter"></vxe-column>
      <vxe-column field="receiptCode" title="发票号" min-width="160"></vxe-column>
      <vxe-column field="totalAmount" title="发票金额" min-width="90"></vxe-column>
      <vxe-column field="payAmount" title="已付款" min-width="90">
        <template #default="{ row }">
          <el-button v-if="row.payAmount>0" type="text" v-text="row.payAmount"
                     @click="showPayLogDialog(row)"></el-button>
          <span v-else v-text="row.payAmount"></span>
        </template>
      </vxe-column>
      <vxe-column field="unPayAmount" title="未付款" min-width="90"></vxe-column>
    </vxe-table>
    <vxe-pager
        :loading="tableData.loading"
        :current-page="tableData.currentPage"
        :page-size="pagerConfig.pageSize"
        :total="tableData.total"
        :layouts="pagerConfig.layouts"
        @page-change="vxePageChanger">
    </vxe-pager>
    <pay-dialog ref="payDialog" @complete="getDataList"></pay-dialog>
    <pay-log-dialog ref="payLogDialog"></pay-log-dialog>
  </el-card>
</template>

<script>
import VxeTable from '@/mixins/vxe-table'
import BigNumber from 'bignumber.js'
import PayDialog from '@/views/modules/fund/pay/pay-dialog'
import PayLogDialog from '@/views/modules/fund/pay/pay-log-dialog'

export default {
  mixins: [VxeTable],
  components: { PayDialog, PayLogDialog },
  data () {
    return {
      tableConfig: {
        queryUrl: '/fund/pay/page',
        footerColumn: ['price', 'count', 'totalAmount', 'payAmount', 'unPayAmount'],
        otherHeight:10
      },
      queryForm: {
        sellerName: '',
        receiptCode: '',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    showPayLogDialog (row) {
      this.$refs.payLogDialog.queryForm.receiptCode = row.receiptCode
      this.$refs.payLogDialog.init()
    },
    showPayDialog () {
      const selData = this.$refs[this.tableConfig.tableName].getCheckboxRecords()
      if (selData.length === 0) {
        return this.$message.error('请选择发票')
      }
      this.$refs.payDialog.dataList = selData.map(item => {
        return {
          ...item,
          id: '',
          payedAmount: item.payAmount,
          payAmount: item.unPayAmount,
          payType: '',
          payNo: '',
          remark: '',
          payTime: ''
        }
      })
      this.$refs.payDialog.init()
    },
    cellStyleHandler ({ row, rowIndex, column }) {
      if (column.property === 'unPayAmount') {
        let unPayAmount = new BigNumber(row.unPayAmount || 0)
        if (unPayAmount.eq(0)) {
          return {
            color: '#67C23A'
          }
        } else {
          return {
            color: '#F56C6C'
          }
        }
      }
    },
    beforeTableBinding (dataList) {
      dataList.forEach(item => {
        let totalAmount = new BigNumber(item.totalAmount)
        item.totalAmount = totalAmount.toFixed(2)
        item.unPayAmount = totalAmount.minus(item.payAmount || 0).toFixed(2)
      })
    },

  }
}
</script>

<style scoped>

</style>
